import React from "react";
import { baseUrl } from '../config';
import SEO from '../components/SEO';



const Company = () => {
  return (
    <div className="min-h-screen bg-gray-100 p-6">
        <SEO
          title="Company Profile"
          description="Manage your production company profile and details on ProducerBuddy."
          url="https://producerbuddy.pilomation.com/company"
          robots="noindex, nofollow"
        />
        {/* Company Introduction */}
        <section className="mb-12 text-center">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">
            Welcome to Our Company
          </h1>
          <p className="text-gray-600 text-lg">
            We are a leading company in the industry, committed to delivering
            the highest quality products and services. Our team of dedicated
            professionals works tirelessly to bring innovative solutions to our
            clients around the world.
          </p>
        </section>

        {/* Mission Statement */}
        <section className="mb-12 mt-4">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            Our Mission
          </h2>
          <p className="text-gray-600 text-lg">
            Our mission is to transform businesses through technology, providing
            cutting-edge solutions that enable companies to thrive in an
            ever-evolving market. We strive to create value for our customers,
            employees, and stakeholders.
          </p>
        </section>

        {/* Vision Statement */}
        <section className="mb-12 mt-4">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            Our Vision
          </h2>
          <p className="text-gray-600 text-lg">
            Our vision is to be recognized as the most innovative and reliable
            company in our industry. We aim to lead the way in sustainable and
            responsible business practices while fostering a culture of
            creativity and collaboration.
          </p>
        </section>

        {/* Core Values */}
        <section className="mb-12 mt-4">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            Our Core Values
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-gray-50 p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-bold text-gray-700 mb-2">Innovation</h3>
              <p className="text-gray-600">
                We encourage creativity and embrace change, striving for
                continuous improvement in everything we do.
              </p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-bold text-gray-700 mb-2">Integrity</h3>
              <p className="text-gray-600">
                We uphold the highest ethical standards in all our dealings, 
                ensuring transparency and trust with our clients and partners.
              </p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-bold text-gray-700 mb-2">Excellence</h3>
              <p className="text-gray-600">
                We are dedicated to delivering superior results through a 
                commitment to quality and a relentless pursuit of excellence.
              </p>
            </div>
          </div>
        </section>

        {/* Team Section */}
        <section className="mb-12 mt-4">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            Meet Our Team
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-gray-50 p-6 rounded-lg shadow-md text-center">
              <img
                src="https://via.placeholder.com/150"
                alt="Team Member"
                className="w-24 h-24 mx-auto rounded-full mb-4"
              />
              <h3 className="text-xl font-bold text-gray-700">John Doe</h3>
              <p className="text-gray-600">CEO</p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg shadow-md text-center">
              <img
                src="https://via.placeholder.com/150"
                alt="Team Member"
                className="w-24 h-24 mx-auto rounded-full mb-4"
              />
              <h3 className="text-xl font-bold text-gray-700">Jane Smith</h3>
              <p className="text-gray-600">CTO</p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg shadow-md text-center">
              <img
                src="https://via.placeholder.com/150"
                alt="Team Member"
                className="w-24 h-24 mx-auto rounded-full mb-4"
              />
              <h3 className="text-xl font-bold text-gray-700">Mike Brown</h3>
              <p className="text-gray-600">COO</p>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="text-center p-3">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            Get In Touch
          </h2>
          <p className="text-gray-600 mb-6">
            If you'd like to learn more about our services or discuss potential
            partnerships, feel free to contact us.
          </p>
          <a
            href="mailto:info@company.com"
            className="inline-block bg-blue-600 text-white px-6 py-3 rounded-lg shadow-md hover:bg-blue-700 transition duration-300"
          >
            Contact Us
          </a>
        </section>
    </div>
  );
};

export default Company;

